/**
 * Created by Gaplo917 on 10/7/2017.
 */

import Scene from "./objects/Scene"
import R from "./config/R"
import Button from "./objects/Button"
import FullScreenBg from "./objects/FullScreenBg"
import * as Events from "./Events"
import * as SoundUtils from "./SoundUtils"
import SoundManager from "./SoundManager";
import {AnimationUtils} from "./AnimationUtils";

export default class Scene1 extends Scene {
  constructor(resources){
    super()

    const initBg = new FullScreenBg(resources[R.images.initBg.name].texture)

    const startBtn = new Button(R.dimen.width / 2, 1200, resources[R.images.startBtn.name].texture, false)

    startBtn.addOnClickListener(() => {
      startBtn.removeOnClickListener()
      startBtn.touchEffect(true)
      this.nextScene()
    })

    this.addChild(initBg)
    this.addChild(startBtn)

    this.startBtn = startBtn
  }


  nextScene(){
    console.log("go to next scene 2")
    AnimationUtils.fadeOut(this.startBtn)

    SoundManager.instance.playEffect(R.sounds.pth_6bs2_p52_ga_01, () => {
      Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.SELECTION })
    })
  }
}



// WEBPACK FOOTER //
// ./src/game/Scene1.js